import { takeLatest, all } from 'redux-saga/effects';

import { requestAndSet } from 'utils/helpers';

import { customFieldsActions } from '../slices/customFieldsSlice';
import { FormField } from '../../types/formFieldTypes';

function* fetchCustomFieldsSaga(
  action: ReturnType<typeof customFieldsActions.fetchCustomFields>,
): Generator {
  const { orgId } = action.payload;

  yield requestAndSet('listAllFormFields', [orgId], {
    createSetterAction: (res: unknown) => {
      const fields = ((res as { data?: unknown[] })?.data ||
        []) as unknown as FormField[];
      const filteredFields = fields.filter(
        (field: FormField) => field.status === 1,
      );
      return customFieldsActions.setCustomFields(filteredFields);
    },
    loadingAction: (v: boolean) =>
      customFieldsActions.setLoading({ key: 'customFieldsLoading', value: v }),
  });
}

export default function* customFieldsSaga(): Generator {
  yield all([
    takeLatest(
      customFieldsActions.fetchCustomFields.type,
      fetchCustomFieldsSaga,
    ),
  ]);
}
